import ScratchTester from '@hetao/scratch-tester';
import { isTeacherMode } from '../hetao-mode'

export default new ScratchTester({
    mode: isTeacherMode() ? 'normal' : 'backend'
});
